import * as React from "react";
import { connect } from "react-redux";

import { Grid, Table, Button } from "semantic-ui-react";
import { ImmunisationListModel, getIdentityValidationOptionsValue } from "@teamprevent/common/immunisation/models";

import { SelectorState, immunisationsSelector } from "../selectors";

import { Link } from "redux-little-router";

interface Props {
    immunisations: ImmunisationListModel[];
    path: string;
}

class AllComponent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Grid container className="nomargintop" >
                <Grid.Row >
                    <Grid.Column width={10}>
                        <h1>Immunisations</h1>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign="right">
                        <Button content="Print" as={Link} href={`${this.props.path}/immunisationRecord`} target="_blank" rel="noopener noreferrer" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <p>
                            If you require a print out of your immunisation record to provide to another employer please ensure you print using the
                            print button so that your print out contains your name, address and date of birth. If any of your details are missing or incorrect
                            please contact us to update your employee record to ensure the most up to date details are displayed on your report.
                        </p>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Immunisation</Table.HeaderCell>
                                    <Table.HeaderCell>Date complete</Table.HeaderCell>
                                    <Table.HeaderCell>Type</Table.HeaderCell>
                                    <Table.HeaderCell>Outcome</Table.HeaderCell>
                                    <Table.HeaderCell>IVS Sample</Table.HeaderCell>
                                    <Table.HeaderCell>Completed by</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.props.immunisations && this.props.immunisations.map(immunisation => (
                                    <Table.Row key={immunisation.id}>
                                        <Table.Cell>
                                            {immunisation.immunisationType.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {immunisation.dateCompleted && immunisation.dateCompleted.format("DD/MM/YYYY")}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {immunisation.recordType}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {immunisation.outcome}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {getIdentityValidationOptionsValue(immunisation.identityValidation)}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {immunisation.completedByName}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

function mapStateToProps(state: SelectorState): Props {
    return {
        path: state.router.pathname,
        immunisations: immunisationsSelector(state)
    };
}

export const All = connect(mapStateToProps)(AllComponent);
